(function () {
  'use strict';

  var API_BASE = 'https://hub.littlegiants.pk';
  var cache = {};

  function esc(s) {
    return (s || '').toString();
  }

  function starsHtml(avg) {
    var full = Math.round(avg || 0);
    var h = '';
    for (var i = 1; i <= 5; i++) h += i <= full ? '★' : '☆';
    return h;
  }

  function render(el, data) {
    if (!data || !data.count) return; // no approved reviews yet — stays hidden
    var showNumber = el.dataset.showNumber === 'true';
    var html = '<span class="hrb-stars" aria-hidden="true">' + starsHtml(data.avg_rating) + '</span>';
    html += '<span class="visually-hidden">' + data.avg_rating + ' out of 5 stars, ' + data.count + ' reviews</span>';
    if (showNumber) {
      html += '<span class="hrb-count">(' + data.count + ')</span>';
    }
    el.innerHTML = html;
    el.hidden = false;
  }

  function fetchSummary(productId) {
    if (cache[productId]) return cache[productId];
    var url = API_BASE + '/api/public/reviews/summary?product_id=' + encodeURIComponent(productId);
    cache[productId] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .catch(function (err) {
        console.warn('[HUB review badge] fetch failed:', err);
        return null;
      });
    return cache[productId];
  }

  function init() {
    document.querySelectorAll('[data-hub-review-badge]').forEach(function (el) {
      var productId = el.dataset.productId;
      if (!productId) return;
      fetchSummary(productId).then(function (data) { render(el, data); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
